import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const roomOptions = [
    '"Black Rock" Suite room — 2.300.000₮',
    '"Blue Pearl" Suite room — 2.500.000₮',
    '"Tatami" Suite room — 2.500.000₮',
    '"Khuvsgul" Suite room — 5.000.000₮',
];

const services = [
    { icon: 'fa-mug-hot',          label: 'Welcome tea on arrival' },
    { icon: 'fa-utensils',         label: 'Breakfast + Afternoon tea' },
    { icon: 'fa-concierge-bell',   label: '24/7 Room service' },
    { icon: 'fa-spa',              label: 'Access to Spa & Wellness' },
    { icon: 'fa-person-hiking',    label: 'Nature & activity programs' },
    { icon: 'fa-wifi',             label: 'High-speed Wi-Fi' },
];

function Booking() {
    const [params] = useSearchParams();
    const preselect = params.get('room') || '';

    const matched = roomOptions.find(function(r) { return r.includes(preselect); }) || '';
    const [room, setRoom] = useState(matched);
    const [submitted, setSubmitted] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const body =
            'Room: '     + data.get('room')     + '\n' +
            'Check-in: ' + data.get('checkin')  + '\n' +
            'Check-out: '+ data.get('checkout') + '\n' +
            'Adults: '   + data.get('adults')   + '\n' +
            'Children: ' + data.get('children') + '\n' +
            'Name: '     + data.get('name')     + '\n' +
            'Phone: '    + data.get('phone')    + '\n' +
            'Email: '    + data.get('email')    + '\n\n' +
            'Special Requests: ' + (data.get('requests') || '—');
        window.location.href =
            'mailto:info.blackrock@rrc.mn' +
            '?subject=' + encodeURIComponent('Reservation Request — ' + data.get('name')) +
            '&body='    + encodeURIComponent(body);
        setSubmitted(true);
    }

    return (
        <>
            {/* Banner */}
            <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="subtitle">Black Rock Luxury Hotel</div>
                            <div className="title">Reserve a Room</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Booking section */}
            <section className="bk-section">
                <div className="container">
                    <div className="bk-inner">

                        {/* Form card */}
                        <div className="bk-form-card">
                            <div className="bk-form-card__label">Reservation Request</div>
                            <h2 className="bk-form-card__title">Book Your Stay</h2>
                            <div className="bk-form-card__divider" />

                            {submitted ? (
                                <div className="bk-success">
                                    <i className="fa-thin fa-circle-check bk-success__icon" />
                                    <h4 className="bk-success__title">Request Received</h4>
                                    <p className="bk-success__desc">Thank you for your reservation request. Our team will contact you within 24 hours to confirm your booking.</p>
                                </div>
                            ) : (
                                <form className="bk-form" onSubmit={handleSubmit}>
                                    <input type="hidden" name="_captcha" value="false" />
                                    <input type="hidden" name="_template" value="table" />

                                    {/* Room */}
                                    <div className="bk-field bk-field--full">
                                        <label className="bk-label">Room Type</label>
                                        <select
                                            name="room"
                                            className="bk-select"
                                            value={room}
                                            onChange={function(e) { setRoom(e.target.value); }}
                                            required
                                        >
                                            <option value="">— Select a room —</option>
                                            {roomOptions.map(function(r) { return (
                                                <option key={r} value={r}>{r}</option>
                                            ); })}
                                        </select>
                                    </div>

                                    {/* Dates */}
                                    <div className="bk-field">
                                        <label className="bk-label">Check-in Date</label>
                                        <input type="date" name="checkin" className="bk-input" required />
                                    </div>
                                    <div className="bk-field">
                                        <label className="bk-label">Check-out Date</label>
                                        <input type="date" name="checkout" className="bk-input" required />
                                    </div>

                                    {/* Guests */}
                                    <div className="bk-field">
                                        <label className="bk-label">Adults</label>
                                        <select name="adults" className="bk-select" required>
                                            {[1,2,3,4].map(function(n) { return <option key={n} value={n}>{n}</option>; })}
                                        </select>
                                    </div>
                                    <div className="bk-field">
                                        <label className="bk-label">Children</label>
                                        <select name="children" className="bk-select">
                                            {[0,1,2,3].map(function(n) { return <option key={n} value={n}>{n}</option>; })}
                                        </select>
                                    </div>

                                    {/* Contact */}
                                    <div className="bk-field bk-field--full">
                                        <label className="bk-label">Full Name</label>
                                        <input type="text" name="name" className="bk-input" placeholder="Your full name" required />
                                    </div>
                                    <div className="bk-field">
                                        <label className="bk-label">Email</label>
                                        <input type="email" name="email" className="bk-input" placeholder="email@example.com" required />
                                    </div>
                                    <div className="bk-field">
                                        <label className="bk-label">Phone</label>
                                        <input type="tel" name="phone" className="bk-input" placeholder="+976 ..." />
                                    </div>

                                    {/* Special requests */}
                                    <div className="bk-field bk-field--full">
                                        <label className="bk-label">Special Requests</label>
                                        <textarea name="requests" className="bk-textarea" rows="3" placeholder="Dietary needs, arrival time, celebrations..." />
                                    </div>

                                    <button type="submit" className="bk-submit">Send Reservation Request</button>
                                </form>
                            )}
                        </div>

                        {/* Info panel */}
                        <div className="bk-info">
                            <div className="bk-info__img-wrap">
                                <img src={`${process.env.PUBLIC_URL}/img/banner/19.jpg`} alt="" className="bk-info__img" />
                                <div className="bk-info__img-overlay">
                                    <div className="bk-info__img-quote">"Where wilderness becomes wonder"</div>
                                    <div className="bk-info__img-sub">Khuvsgul Lake · Mongolia</div>
                                </div>
                            </div>

                            <div className="bk-info__body">
                                <div className="bk-info__section-title">What's Included</div>
                                <ul className="bk-services">
                                    {services.map(function(s) { return (
                                        <li key={s.label} className="bk-service-item">
                                            <i className={`fa-thin ${s.icon} bk-service-item__icon`} />
                                            <span>{s.label}</span>
                                        </li>
                                    ); })}
                                </ul>

                                <div className="bk-info__divider" />

                                <div className="bk-info__section-title">Contact Us Directly</div>
                                <div className="bk-contact-row">
                                    <i className="fa-thin fa-phone" />
                                    <a href="tel:+97677109191">+976 77109191</a>
                                </div>
                                <div className="bk-contact-row">
                                    <i className="fa-thin fa-envelope" />
                                    <a href="mailto:info.blackrock@rrc.mn">info.blackrock@rrc.mn</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}

export default Booking;
